import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import $ from 'jquery'; // material ui component

import MuiCheckbox from '@material-ui/core/Checkbox';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import { wireChecked } from './hoc/prop-wire';
/**
 * A React Checkbox
 * @constructor
 * @param {string} [id] - Container dom element #id
 * @param {string} [className] - Classname for the container
 * @param {boolean} [asRadio] - Show as RadioButton
 * @param {boolean} [defaultChecked] - Default checked value
 * @param {boolean} [checked] - Current checked value
 * @param {object} [checkedLink] - Link to update check value. Used in conjuction with [linked-state-mixins]{@link module:linked-state-mixins}
 * @param {*} checkedLink.value - value to update
 * @param {function} checkedLink.requestChange - function to request check value change
 * @param {boolean} [disabled=false] - Is checkbox disabled?
 * @param {function} onChange  - Callback function when checkbox is ticked/unticked. <br> Required when value prop is supplied
 * @param {boolean} onChange.checked - checked?
 * @param {object} onChange.eventInfo - event related info
 * @param {boolean} onChange.eventInfo.before - was checked or unchecked?
 *
 * @example
// controlled

import {Checkbox} from 'react-ui'
React.createClass({
  getInitialState() {
    return {subscribe:false}
  },
  handleChange(subscribe) {
    this.setState({subscribe})
  },
  render() {
    const {subscribe} = this.state;
    return <div className='c-flex aic'>
      <label htmlFor='subscribe'>Would you like to subscribe to this newsletter?</label>
      <Checkbox id='subscribe'
        onChange={this.handleChange}
        checked={subscribe}/>
    </div>
  }
})
 */

var Checkbox = /*#__PURE__*/function (_React$Component) {
  _inherits(Checkbox, _React$Component);

  var _super = _createSuper(Checkbox);

  function Checkbox() {
    var _this;

    _classCallCheck(this, Checkbox);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "getLabelForCheckbox", function () {
      var id = _this.props.id;
      return $(_this.node).parent().find("label[for=\"".concat(id, "\"]"));
    });

    _defineProperty(_assertThisInitialized(_this), "handleChange", function (evt) {
      evt.stopPropagation();
      var _this$props = _this.props,
          onChange = _this$props.onChange,
          checked = _this$props.checked;
      onChange(!checked, evt);
    });

    return _this;
  }

  _createClass(Checkbox, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var _this$props2 = this.props,
          id = _this$props2.id,
          disabled = _this$props2.disabled;

      if (id && !disabled) {
        this.getLabelForCheckbox().on('click', function (evt) {
          _this2.handleChange(evt);
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.getLabelForCheckbox().off();
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props3 = this.props,
          id = _this$props3.id,
          className = _this$props3.className,
          checked = _this$props3.checked,
          disabled = _this$props3.disabled,
          asRadio = _this$props3.asRadio,
          color = _this$props3.color,
          size = _this$props3.size,
          indeterminate = _this$props3.indeterminate;
      var displayType = asRadio ? 'ridiobtn' : 'checkbox';
      return /*#__PURE__*/React.createElement(MuiCheckbox, {
        id: id,
        inputRef: function inputRef(ref) {
          _this3.node = ref;
        },
        className: className,
        checked: checked,
        indeterminate: indeterminate,
        color: color,
        disabled: disabled,
        size: size,
        onClick: disabled ? null : this.handleChange,
        onKeyPress: disabled ? null : this.handleChange // className={cx(
        //   `c-${displayType}`,
        //   'fg',
        //   checked ? `fg-${displayType}` : `fg-${displayType}-outline`,
        //   { disabled },
        //   className
        // )}

      }) // <i
      //   id={id}
      //   ref={(ref) => {
      //     this.node = ref;
      //   }}
      //   onClick={disabled ? null : this.handleChange}
      //   onKeyPress={disabled ? null : this.handleChange}
      //   className={cx(
      //     `c-${displayType}`,
      //     'fg',
      //     checked ? `fg-${displayType}` : `fg-${displayType}-outline`,
      //     { disabled },
      //     className
      //   )}
      // />
      ;
    }
  }]);

  return Checkbox;
}(React.Component);

Checkbox.propTypes = {
  id: PropTypes.string,
  className: PropTypes.string,
  checked: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  // checked can be true|false|'partial'
  disabled: PropTypes.bool,
  indeterminate: PropTypes.bool,
  onChange: PropTypes.func,
  asRadio: PropTypes.bool,
  color: PropTypes.string,
  size: PropTypes.string
};
Checkbox.defaultProps = {
  asRadio: false,
  disabled: false,
  color: 'primary',
  size: 'small'
};
export default wireChecked(Checkbox);